import { createComponent } from '@carvana/merch-components';

export const Aside = createComponent('aside', {
  className: `
    sticky
    top-xl
    hidden
    h-fit
    max-h-[calc(100vh-48px)]
    w-full
    overflow-y-auto
    bg-background-default
    md:block`
});
